import styles from "../Cadastro/Styles/CadastroQot.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faUpRightFromSquare, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, /* useRef */ } from "react";
import logo from "../../assets/logo_1_qot.jpeg";
import { Input } from "../../components/Input/Input";
import Checkbox from "../../components/Checkbox/Checkbox";
import Radio from "../../components/Radio/Radio";
import Select from "../../components/Select/Select";
import { validaCpf, validaData } from "../../components/validacoes";
import Swal from "sweetalert2";
//import { useNavigate } from "react-router-dom";
import { swalTheme, Toast } from "../../services/Swal";
import { ContainedBtn, OutlineBtn } from "../../components/ButtonTypes/Button";
import {
  AlignRight,
  InputArea,
  InputAreaDupla,
} from "../../components/Box/Box";
import Widget, { setWidgetIsOpen } from "../../components/Widget/Widget";

function CadastroQot() {
  //const navigate = useNavigate();
  const [termos, setTermos] = useState([{}]);
  // const deficiencia = useRef([])
  const [estados, setEstados] = useState([]);
  const [cidades, setCidades] = useState([]);
  // const [instituicoes, setInstituicoes] = useState([]);
  const [idade, setIdade] = useState();
  // const [filterString, setFilterString] = useState("");
  const [loading, setLoading] = useState(false);
  const [semNumero, setSemNumero] = useState(false);
  const [toggleSenha, setToggleSenha] = useState(false);
  const [deficiencia, setDeficiencia] = useState([]);
  const [form, setForm] = useState({
    nacionalidade: "Brasileiro",
    endereco: {
      pais: "Brasil"
    }
  });

  const subButtonStyle = { fontSize: ".6em", padding: ".3em .5em", margin: ".1em" }

  function handleToggleSenha(e) {
    e.preventDefault();
    setToggleSenha(!toggleSenha);
  };

  function checkSenha(
    password,
    ifWrong = () => {
      Toast.fire({
        icon: "error",
        title:
          "A senha deverá conter no mínimo oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial.",
      });
      setForm({
        ...form,
        senha: "",
      });
    }
  ) {
    if (!password) return;
    const pattern = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W]).{8,64})/g;

    if (pattern.test(password)) return password;
    return ifWrong;
  }

  function validaSenha(senha, confirmaSenha) {
    if (senha !== confirmaSenha) {
      Toast.fire({
        icon: "error",
        title: "Confirmação de senha inválida",
      });
      setForm({
        ...form,
        //senha: "",
        confirmaSenha: "",
      });
    }
  }

  function checkCep(e) {
    const cep = e.target.value;
    if (!cep) return;
    fetch(`https://viacep.com.br/ws/${cep}/json/`)
      .then((res) => res.json())
      .then((cep) => {
        if (cep.erro) {
          Toast.fire({
            icon: "info",
            title: "CEP não localizado",
          });
        } else {
          setForm({
            ...form,
            endereco: {
              ...form.endereco,
              logradouro: cep.logradouro,
              bairro: cep.bairro,
              complemento: cep.complemento,
              estado: cep.uf,
              cidade: cep.localidade,
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
        setForm({
          ...form,
          endereco: {
            ...form.endereco,
            cep: "",
          },
        });
        Toast.fire({
          icon: "error",
          title: "CEP inválido",
        });
      });
  }

  function handleDataNascimento(data) {
    if (!data) return;

    if (!validaData(data)) {
      setForm({ ...form, dataNascimento: "" });
      setIdade(null)
      Toast.fire({
        icon: "error",
        title: "Data inválida",
      });
      return;
    }

    let idade = validaData(data)
    setIdade(idade)

    if (idade >= 18) setForm({ ...form, resp: null })

    if (!(idade > 14) || !(idade < 100)) {
      setForm({ ...form, dataNascimento: "" });
      setIdade(null)
      Toast.fire({
        icon: "error",
        title: "A idade precisa ser maior que 14 anos e menor que 100 anos",
      });
      return;
    }

  }

  function handleCPF(cpf) {
    if (!cpf) return;
    if (!validaCpf(cpf)) {
      setForm({ ...form, cpf: "" });
      Toast.fire({
        icon: "error",
        title: "CPF inválido",
      });
    }
  }

  function handleRespCPF(cpf) {
    if (!cpf) return;
    if (!validaCpf(cpf)) {
      setForm({
        ...form,
        resp: { ...form.resp, cpfResponsavel: "" },
      })
      Toast.fire({
        icon: "error",
        title: "CPF inválido",
      });
    }
  }

  async function getTermos() {
    await fetch(`${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/GetTermos/Cadastro?projeto=QuebrandoTabu`)
      .then((response) => response.json())
      .then((data) => setTermos(data.payload));
  }

  async function selectEstado() {
    await fetch(process.env.REACT_APP_API_ESTADO)
      .then((response) => response.json())
      .then((data) => setEstados(data));
  }

  async function selectCidade(uf) {
    if (!uf) return;
    await fetch(`${process.env.REACT_APP_API_ESTADO}/${uf}/municipios`)
      .then((response) => response.json())
      .then((data) => setCidades(data));
  }

  async function submitForm(obj) {
    setLoading(true)

    const termosEnviar = [];
    Object.keys(form?.termos).map((termo) => {
      return termosEnviar.push({
        nome: termo,
        aceite: form?.termos[termo],
      });
    });

    //replace nos termos originais.
    // let body = { ...obj, deficiencia: deficiencia.current, termos: termosEnviar }
    let body = { ...obj, deficiencia: deficiencia, termos: termosEnviar }
    console.warn(body);

    const request = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    };

    await fetch(`${process.env.REACT_APP_BACKEND}/api/QuebrandoTabu/CadastroQuebrandoTabu`, request)
      .then((response) => response.text())
      .then((result) => {
        result = JSON.parse(result);
        if (result.success)
          return Swal.fire({
            title: "Sucesso!",
            text: "O seu cadastro foi efetuado com sucesso!",
            icon: "success",
            ...swalTheme,
          }).then(() => {
            //navigate("/");
            window.location.replace("https://qot.recode.org.br/");
          });

        return Swal.fire({
          title: "Erro",
          text: result.message,
          icon: "error",
          ...swalTheme,
        });
      })
      .catch((error) => {
        console.log("error", error);
        Swal.fire({
          title: "Erro",
          text: "Um erro ocorreu!",
          icon: "error",
          ...swalTheme,
        });
      }).finally(() => setLoading(false));
  }

  function validaTermos() {
    const termosObrigatorios = termos.filter((termo) => termo.obrigatorio);
    let validou = true;

    termosObrigatorios.map((termo) => !form.termos?.[termo.nome] ? (validou = false) : null);

    if (validou) {
      submitForm(form);
    } else {
      Toast.fire({
        icon: "error",
        title:
          "O aceite dos termos de concentimento e política de dados Recode serão necessários.",
      });
    }
  }

  useEffect(() => {
    selectEstado();
  }, []);

  useEffect(() => {
    getTermos();
  }, []);

  useEffect(() => {
    selectCidade(form?.endereco?.estado);
  }, [form?.endereco?.estado]);

  // useEffect(() => {
  //   fetch("https://sganew.recode.org.br/api/publics/ceds")
  //     .then(res => res.json())
  //     .then(i => setInstituicoes(i))
  //     .catch(e => console.error(e))
  // }, [])


  const [isWidgetLoading, setIsWidgetLoading] = useState(false)
  const [widgetForm, setWidgetForm] = useState({
    nome: "",
    email: "",
    assunto: "",
    projeto: "QOT",
    corpo: ""
  });

  async function submitWidget() {
    setIsWidgetLoading(true)
    console.log(widgetForm)
    await fetch(`${process.env.REACT_APP_BACKEND}/api/PlataformaRecode/DispararEmail`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        nomeRementente: widgetForm.nome,
        emailRemetente: widgetForm.email,
        projeto: widgetForm.projeto,
        assunto: widgetForm.assunto,
        corpo: widgetForm.corpo
      }),
    })
      .then((response) => response.json())
      .then((result) => {
        if (result.success) {
          Toast.fire({ icon: "success", title: "Sua mensagem foi enviada com sucesso!" });
          setWidgetForm({ nome: "", email: "", assunto: "", projeto: "QOT", corpo: "" })
        } else {
          Toast.fire({ icon: "warning", title: "Espere alguns instantes para enviar uma nova mensagem." });
        }
      })
      .catch((error) => {
        console.log("error", error);
        Toast.fire({ icon: "Erro", title: "Um erro ocorreu!" });
      })
      .finally(() => {
        setIsWidgetLoading(false)
        setWidgetIsOpen(false)
      });
  }

  return (
    <>
      <Widget
        content={
          <form
            style={{ display: "flex", gap: "5px", flexDirection: "column" }}
            onSubmit={(e) => {
              e.preventDefault();
              submitWidget();
            }}
          >
            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Nome"
                value={widgetForm.nome}
                onChange={(e) => setWidgetForm({ ...widgetForm, nome: e.target.value })}
              />
            </InputArea>

            <InputArea>
              <Input
                disabled={isWidgetLoading}
                className={styles.input}
                required
                label="Email"
                type="email"
                placeholder="estudante@email.com"
                value={widgetForm.email}
                onChange={(e) => setWidgetForm({ ...widgetForm, email: e.target.value })}
              />
            </InputArea>

            <InputArea>
              <Select
                disabled={isWidgetLoading}
                className={styles.select}
                required
                label="Assunto"
                onChange={(e) => setWidgetForm({ ...widgetForm, assunto: e.target.value })}
              >
                <option>Elogio</option>
                <option>Dúvida</option>
                <option>Cadastro</option>
                <option>Problema técnico</option>
                <option>Outro</option>
              </Select>
            </InputArea>

            <InputArea>
              <textarea
                disabled={isWidgetLoading}
                className={styles.textarea}
                required
                rows={5}
                placeholder="Sua mensagem"
                value={widgetForm.corpo}
                onChange={(e) => setWidgetForm({ ...widgetForm, corpo: e.target.value })}
              ></textarea>
            </InputArea>

            <InputArea>
              <ContainedBtn className={styles.submitBtn} disabled={isWidgetLoading} > {!isWidgetLoading ? "Enviar" : "Enviando..."} </ContainedBtn>
            </InputArea>
          </form>
        }
      />

      <section>
        <img src={logo} className={styles.logo} alt="logo" />
      </section>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          validaTermos();
        }}
      >
        <section className={styles.formArea}>
          <InputAreaDupla>
            <h1>Dados de acesso</h1>
            <hr className={styles.separador} />
          </InputAreaDupla>

          <InputAreaDupla>
            <Input
              className={styles.input}
              required
              label="Email"
              type="email"
              placeholder="estudante@email.com"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
            />
          </InputAreaDupla>

          <InputArea>
            <Input
              className={styles.input}
              required
              value={form.senha}
              label="Senha"
              type={toggleSenha ? "text" : "password"}
              onChange={(e) => setForm({ ...form, senha: e.target.value })}
              onBlur={checkSenha(form.senha)}
              subText="A senha deverá conter no mínimo oito dígitos, ao menos um número, uma letra maiúscula e um caractere especial."
            />
          </InputArea>

          <InputArea>
            <Input
              className={styles.input}
              required

              value={form.confirmaSenha}
              label="Confirmação de Senha"
              type={toggleSenha ? "text" : "password"}
              onChange={(e) => setForm({ ...form, confirmaSenha: e.target.value })}
              onBlur={() => validaSenha(form.senha, form.confirmaSenha)}
              subButton={
                <OutlineBtn
                  onClick={handleToggleSenha}
                  className={styles.inputBtn}
                  style={subButtonStyle}
                >
                  {toggleSenha ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                </OutlineBtn>
              }
            />
          </InputArea>

          <InputAreaDupla>
            <h1>Dados pessoais</h1>
            <hr className={styles.separador} />
          </InputAreaDupla>

          <InputAreaDupla>
            <Input
              className={styles.input}
              required
              label="Nome Completo"
              type="text"
              value={form.nomeCompleto}
              onChange={(e) => setForm({ ...form, nomeCompleto: e.target.value })}
            />
          </InputAreaDupla>

          <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Como se identifica em relação ao seu gênero?"
              onChange={(e) => setForm({ ...form, genero: e.target.value })}
            >
              <option>Homem</option>
              <option>Homem trans</option>
              <option>Mulher</option>
              <option>Mulher trans</option>
              <option>Prefiro não informar</option>
              <option>Outro</option>
            </Select>
          </InputAreaDupla>

          {form.genero === "Outro" && (
            <InputAreaDupla>
              <Input
                className={styles.input}
                label="Qual?"
                type="text"
                value={form.generoOutro}
                onChange={(e) => setForm({ ...form, generoOutro: e.target.value })}
              />
            </InputAreaDupla>
          )}

          {["Outro", "Homem trans", "Mulher trans"].includes(form.genero) && (
            <InputAreaDupla>
              <Input
                required={form.usouNomeSocial}
                className={styles.input}
                label="Nome Social Completo"
                subText="Nome social é a designação pela qual a pessoa travesti ou transexual se identifica e é socialmente reconhecida (DECRETO Nº 8.727, DE 28 DE ABRIL DE 2016)."
                type="text"
                value={form.nomeSocial}
                onChange={(e) => setForm({ ...form, nomeSocial: e.target.value })}
              />
            </InputAreaDupla>
          )}

          {["Outro", "Homem trans", "Mulher trans"].includes(form.genero) && (
            <InputAreaDupla>
              <Checkbox
                checked={form.usouNomeSocial}
                className={styles.checkbox}
                label="Desejo utilizar meu nome social na plataforma e na emissão de certificados"
                name="usoNomeSocial"
                onChange={(e) =>
                  setForm({ ...form, usouNomeSocial: e.target.checked })
                }
              >
                Desejo utilizar meu nome social na plataforma e na emissão de certificados
              </Checkbox>
            </InputAreaDupla>
          )}

          <InputAreaDupla>
            <Input
              className={styles.input}
              required
              label="Data de nascimento"
              type="date"
              subText={idade ? `Eu tenho ${idade} anos de idade.` : null}
              value={form.dataNascimento}
              onChange={(e) =>
                setForm({ ...form, dataNascimento: e.target.value })
              }
              onBlur={(e) => handleDataNascimento(e.target.value)}
            />
          </InputAreaDupla>

          <InputArea>
            <span className={styles.label}>Nacionalidade</span>
            <div
              onChange={(e) => {
                const copia = { ...form };
                delete copia.cpf;
                delete copia.documentoIdentificacao;
                setForm({ ...copia, nacionalidade: e.target.value });
              }}
            >
              <Radio
                label="Brasileira"
                name="nacionalidade"
                value="Brasileiro"
                defaultChecked
                onChange={(e) =>
                  setForm({ ...form, nacionalidade: e.target.value })
                }
                className={styles.radio}
              />

              <Radio
                label="Outra"
                name="nacionalidade"
                value="outro"
                onChange={(e) =>
                  setForm({ ...form, nacionalidade: e.target.value })
                }
                className={styles.radio}
              />
            </div>
          </InputArea>

          {form.nacionalidade === "outro" && (
            <InputArea>
              <Input
                className={styles.input}
                required
                label="Qual"
                value={form.nacionalidadeOutro}
                onChange={(e) => setForm({ ...form, nacionalidadeOutro: e.target.value })}
              />
            </InputArea>
          )}

          {form.nacionalidade !== "outro" && (
            <InputAreaDupla>
              <Input
                className={styles.input}
                required
                label="CPF"
                mask="999.999.999-99"
                placeholder="000.000.000-00"
                value={form.cpf}
                onChange={(e) => setForm({ ...form, cpf: e.target.value })}
                onBlur={(e) => {
                  handleCPF(e.target.value);
                }}
              />
            </InputAreaDupla>
          )}

          {form.nacionalidade === "outro" && (
            <InputAreaDupla>
              <Input
                required
                className={styles.input}
                label="Documento de identificação "
                type="text"
                value={form.documentoIdentificacao}
                onChange={(e) => setForm({ ...form, documentoIdentificacao: e.target.value })}
              />
            </InputAreaDupla>
          )}

          {idade < 18 && (
            <>
              <InputAreaDupla>
                <h1>Dados do responsável</h1>
                <hr className={styles.separador} />
              </InputAreaDupla>

              <InputAreaDupla>
                <Input
                  className={styles.input}
                  required
                  label="Nome Completo"
                  type="text"
                  value={form.resp?.nomeResponsavel}
                  onChange={(e) => setForm({ ...form, resp: { ...form.resp, nomeResponsavel: e.target.value } })}
                />
              </InputAreaDupla>

              <InputAreaDupla>
                <Select
                  className={styles.select}
                  required
                  label="Grau de parentesco do responsável informado"
                  onChange={(e) => setForm({ ...form, resp: { ...form.resp, grauParentesco: e.target.value } })}
                >
                  <option>Pai</option>
                  <option>Mãe</option>
                  <option>Avô</option>
                  <option>Avó</option>
                  <option>Outro</option>
                </Select>
              </InputAreaDupla>

              {form.resp?.grauParentesco === "Outro" && (
                <InputAreaDupla>
                  <Input
                    className={styles.input}
                    required
                    label="Qual?"
                    value={form.resp?.grauParentescoOutro}
                    onChange={(e) => setForm({ ...form, resp: { ...form.resp, grauParentescoOutro: e.target.value } })}
                  />
                </InputAreaDupla>
              )}

              <InputAreaDupla>
                <Input
                  className={styles.input}
                  required
                  label="CPF do seu responsável"
                  mask="999.999.999-99"
                  placeholder="000.000.000-00"
                  value={form.resp?.cpfResponsavel}
                  onChange={(e) => setForm({ ...form, resp: { ...form.resp, cpfResponsavel: e.target.value } })}
                  onBlur={(e) => handleRespCPF(e.target.value)}
                />
              </InputAreaDupla>
            </>
          )}

          <InputAreaDupla>
            <h1>Dados de contato</h1>
            <hr className={styles.separador} />
          </InputAreaDupla>

          <InputArea>
            <Input
              className={styles.input}
              label="Telefone"
              type="tel"
              mask="(99) 99999-9999"
              placeholder="(00) 99999-9999"
              value={form.telefone}
              onChange={(e) => setForm({ ...form, telefone: e.target.value })}
              onBlur={() => (
                form.telefone.length < 15
                  ? setForm({ ...form, telefone: "" })
                  : null
              )}
            />
          </InputArea>

          <InputArea>
            <span className={styles.label}>Whatsapp</span>
            <div>
              <Checkbox
                className={styles.checkbox}
                label="Este telefone é meu whatsapp"
                name="whatsapp"
                value="sim"
                checked={form.whatsapp}
                onChange={(e) =>
                  setForm({ ...form, whatsapp: e.target.checked })
                }
              >
                Este telefone é meu whatsapp
              </Checkbox>
            </div>
          </InputArea>

          <InputArea>
            <Input
              className={styles.input}
              label="CEP"
              mask="99999-999"
              placeholder="00000-000"
              value={form.endereco?.cep}
              onBlur={checkCep}
              onChange={(e) =>
                setForm({
                  ...form,
                  endereco: { ...form.endereco, cep: e.target.value },
                })
              }
            />
          </InputArea>

          <InputArea>
            <Select
              className={styles.select}
              label="Estado"
              required
              value={form.endereco?.estado}
              onChange={(e) =>
                setForm({
                  ...form,
                  endereco: { ...form.endereco, estado: e.target.value },
                })
              }
            >
              {estados
                .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
                .map((estado) => (
                  <option key={estado.id} value={estado.sigla}>
                    {estado.nome}
                  </option>
                ))}
            </Select>
          </InputArea>

          <InputArea>
            <Select
              className={styles.select}
              value={form.endereco?.cidade}
              label="Cidade"
              required
              disabled={!form?.endereco?.estado}
              onChange={(e) =>
                setForm({
                  ...form,
                  endereco: { ...form.endereco, cidade: e.target.value },
                })
              }
            >
              {cidades
                .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
                .map((cidade) => (
                  <option key={cidade.id} value={cidade.sigla}>
                    {cidade.nome}
                  </option>
                ))}
            </Select>
          </InputArea>

          <InputArea>
            <Input
              className={styles.input}
              label="Bairro"
              value={form.endereco?.bairro}
              onChange={(e) =>
                setForm({
                  ...form,
                  endereco: { ...form.endereco, bairro: e.target.value },
                })
              }
            />
          </InputArea>

          <InputArea>
            <Input
              className={styles.input}
              label="Endereço/Rua/Avenida"
              value={form.endereco?.logradouro}
              onChange={(e) =>
                setForm({
                  ...form,
                  endereco: { ...form.endereco, logradouro: e.target.value },
                })
              }
            />
          </InputArea>

          <InputArea>
            <Input
              className={styles.input}
              required={!semNumero}
              disabled={semNumero}
              subButton={
                <OutlineBtn
                  onClick={(e) => {
                    e.preventDefault()
                    setSemNumero(c => !c)
                    setForm({
                      ...form,
                      endereco: { ...form.endereco, numero: "" },
                    })
                  }}
                  className={styles.inputBtn}
                  style={subButtonStyle}
                >
                  {semNumero ? "Tenho número" : "Não tenho número"}
                </OutlineBtn>
              }
              label="Número"
              value={form.endereco?.numero}
              onChange={(e) =>
                setForm({
                  ...form,
                  endereco: { ...form.endereco, numero: e.target.value },
                })
              }
            />
          </InputArea>

          <InputAreaDupla>
            <Input
              className={styles.input}
              label="Complemento"
              value={form.endereco?.complemento}
              onChange={(e) =>
                setForm({
                  ...form,
                  endereco: { ...form.endereco, complemento: e.target.value },
                })
              }
            />
          </InputAreaDupla>

          <InputAreaDupla>
            <h1>Queremos saber mais sobre você</h1>
            <hr className={styles.separador} />
          </InputAreaDupla>

          <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Como se identifica em relação a sua raça/etnia?"
              onChange={(e) => setForm({ ...form, etnia: e.target.value })}
            //subText="Categorias utilizadas pelo CENSO"
            >
              <option>Amarela</option>
              <option>Branca</option>
              <option>Indígena</option>
              <option>Parda</option>
              <option>Preta/Negra</option>
              <option>Prefiro não informar</option>
              <option>Outro</option>
            </Select>
          </InputAreaDupla>

          {form.etnia === "Outro" && (
            <InputAreaDupla>
              <Input
                className={styles.input}
                label="Qual?"
                value={form.etniaOutro}
                onChange={(e) => setForm({ ...form, etniaOutro: e.target.value })}
              />
            </InputAreaDupla>
          )}

          <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Você se identifica como LGBTQIAPN+?"
              onChange={(e) => setForm({ ...form, lgbt: e.target.value })}
              subText="A sigla LGBTQIAPN+ representa pessoas que são Lésbicas, Gays, Bissexuais, Transexuais, Queer, Intersexo, Assexuais, Pansexuais e Não-binárias."
            >
              <option>Sim</option>
              <option>Não</option>
              <option>Prefiro não informar</option>
            </Select>
          </InputAreaDupla>

          <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Você é uma pessoa com deficiência?"
              onChange={(e) => setForm({ ...form, pcd: e.target.value })}
            >
              <option>Sim</option>
              <option>Não</option>
              <option>Prefiro não informar</option>
            </Select>
          </InputAreaDupla>

          {form.pcd === "Sim" && (
            <InputAreaDupla>
              <span className={styles.label}>Selecione</span>
              <Checkbox
                value='Deficiência auditiva'
                className={styles.checkbox}
                checked={deficiencia.includes('Deficiência auditiva')}
                onChange={(e) => { deficiencia.includes(e.target.value) ? setDeficiencia(deficiencia.filter((val) => val !== e.target.value)) : setDeficiencia([...deficiencia, e.target.value]) }}
              >
                Deficiência auditiva
              </Checkbox>

              <Checkbox
                value='Deficiência visual'
                className={styles.checkbox}
                checked={deficiencia.includes('Deficiência visual')}
                onChange={(e) => { deficiencia.includes(e.target.value) ? setDeficiencia(deficiencia.filter((val) => val !== e.target.value)) : setDeficiencia([...deficiencia, e.target.value]) }}
              >
                Deficiência visual
              </Checkbox>

              <Checkbox
                value='Deficiência física'
                className={styles.checkbox}
                checked={deficiencia.includes('Deficiência física')}
                onChange={(e) => { deficiencia.includes(e.target.value) ? setDeficiencia(deficiencia.filter((val) => val !== e.target.value)) : setDeficiencia([...deficiencia, e.target.value]); }}
              >
                Deficiência física
              </Checkbox>

              <Checkbox
                value='Deficiência intelectual'
                className={styles.checkbox}
                checked={deficiencia.includes('Deficiência intelectual')}
                onChange={(e) => { deficiencia.includes(e.target.value) ? setDeficiencia(deficiencia.filter((val) => val !== e.target.value)) : setDeficiencia([...deficiencia, e.target.value]); }}
              >
                Deficiência intelectual
              </Checkbox>
            </InputAreaDupla>
          )}

          <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Você se considera refugiado?"
              subText="Refugiado/a é a pessoa que está “fora de seu país de origem devido a fundados temores de perseguição relacionados a questões de raça, religião, nacionalidade, pertencimento a um determinado grupo social ou opinião política, como também devido à grave e generalizada violação de direitos humanos e conflitos armados”, segundo a ACNUR, Agência da ONU para Refugiados."
              onChange={(e) => setForm({ ...form, refugiado: e.target.value })}
            >
              <option>Sim</option>
              <option>Não</option>
              <option>Prefiro não informar</option>
            </Select>
          </InputAreaDupla>

          <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Qual é o seu nível de escolaridade mais alto?"
              onChange={(e) => setForm({ ...form, escolaridade: e.target.value })}
            >
              <option>Ensino Fundamental incompleto</option>
              <option>Ensino Fundamental completo</option>
              <option>Ensino Médio/Técnico incompleto</option>
              <option>Ensino Médio/Técnico completo</option>
              <option>Graduação incompleta</option>
              <option>Graduação completa ou mais</option>
            </Select>
          </InputAreaDupla>

          <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Você está trabalhando?"
              onChange={(e) => setForm({ ...form, trabalhando: e.target.value })}
            >
              <option>Sim, com carteira assinada (incluindo Jovem Aprendiz)</option>
              <option>Sim, sem carteira assinada, mas com contrato (microempreendedor individual, Pessoa Jurídica, etc)</option>
              <option>Sim, informal ou bicos</option>
              <option>Sim, sou servidor/a público</option>
              <option>Não estou trabalhando</option>
              <option>Prefiro não informar</option>
            </Select>
          </InputAreaDupla>

          {[
            "Sim, com carteira assinada (incluindo Jovem Aprendiz)",
            "Sim, sem carteira assinada, mas com contrato (microempreendedor individual, Pessoa Jurídica, etc)",
            "Sim, informal ou bicos",
            "Sim, sou servidor/a público"
          ].includes(form.trabalhando) && (
              <InputAreaDupla>
                <Select
                  className={styles.select}
                  required
                  label="De quanto foi sua renda no último mês?"
                  onChange={(e) => setForm({ ...form, renda: e.target.value })}
                >
                  <option>Até R$660,00</option>
                  <option>Entre R$661,01 e R$1.320,00</option>
                  <option>Entre R$1.320,01 e R$2.640,00</option>
                  <option>Entre R$2.640,01 e R$3.960,00</option>
                  <option>R$3.960,01 ou mais</option>
                  <option>Prefiro não informar</option>
                </Select>
              </InputAreaDupla>
            )}

          {/* <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Como fará os cursos? "
              onChange={(e) => setForm({ ...form, comoFaraCursos: e.target.value })}
            >
              <option>Farei em uma biblioteca</option>
              <option>Farei em uma escola</option>
              <option>Farei em uma ONG, associação, etc</option>
              <option>Farei em outro tipo de instituição</option>
              <option>Farei sozinha(o)</option>
            </Select>
          </InputAreaDupla>

          {["Farei em uma biblioteca", "Farei em uma escola", "Farei em uma ONG, associação, etc"].includes(form.comoFaraCursos) && (
            <>
              <InputArea>
                <Input
                  className={styles.input}
                  label="Filtrar"
                  type="search"
                  placeholder="Comece a digitar o nome da instituição e, depois, selecione na lista"
                  value={filterString}
                  onChange={(e) => setFilterString(e.target.value)}
                />
              </InputArea>
              <InputArea>
                <Select
                  className={styles.select}
                  required
                  label="Qual?"
                  onChange={(e) => setForm({ ...form, instituicao: e.target.value })}
                >
                  {instituicoes
                    .filter((f) => !f.nome.toUpperCase().includes("teste".toUpperCase()))
                    .filter((f) => f.nome.toUpperCase().includes(filterString.toUpperCase()))
                    .map(instituicao => <option key={instituicao.id}>{instituicao.nome}</option>)}
                </Select>
              </InputArea>
            </>
          )}

          {form.comoFaraCursos === "Farei em outro tipo de instituição" && (
            <InputAreaDupla>
              <Input
                className={styles.input}
                label="Qual"
                value={form.instituicaoOutro}
                onChange={(e) => setForm({ ...form, instituicaoOutro: e.target.value })}
              />
            </InputAreaDupla>
          )} */}

          <InputAreaDupla>
            <Select
              className={styles.select}
              required
              label="Como ficou sabendo deste projeto?"
              onChange={(e) => setForm({ ...form, ficouSabendo: e.target.value })}
            >
              <option>No projeto ou instituição que participo</option>
              <option>Indicação de amigos/família/conhecidos</option>
              <option>Email da Recode</option>
              <option>Facebook</option>
              <option>Instagram</option>
              <option>Quebrando o Tabu</option>
              <option>LinkedIn</option>
              <option>Televisão</option>
              <option>Youtube</option>
              <option>Outro</option>
            </Select>
          </InputAreaDupla>

          {form.ficouSabendo === "Outro" && (
            <InputAreaDupla>
              <Input
                className={styles.input}
                label="Qual"
                value={form.ficouSabendoOutro}
                onChange={(e) => setForm({ ...form, ficouSabendoOutro: e.target.value })}
              />
            </InputAreaDupla>
          )}

          <InputAreaDupla>
            <h1>Termos</h1>
            <hr className={styles.separador} />
          </InputAreaDupla>

          {termos
            .sort((a, b) =>
              a.obrigatorio > b.obrigatorio
                ? 1
                : b.obrigatorio > a.obrigatorio
                  ? -1
                  : 0
            )
            .map((termo, index) => (
              <InputAreaDupla key={index}>
                <Checkbox
                  key={termo.nome}
                  className={styles.checkbox}
                  // value={form[termo.nome]}
                  checked={form?.termos?.[termo?.nome]}
                  onChange={(e) => {
                    setForm({
                      ...form,
                      termos: {
                        ...form.termos,
                        [termo.nome]: e.target.checked,
                      },
                    });
                  }}
                  required
                >
                  <span>
                    {termo.descricao + " "}
                    {termo.obrigatorio && "* "}
                    {termo.link && (
                      <a
                        className={styles.checkboxA}
                        rel="noopener noreferrer"
                        href={termo.link}
                        target="_blank"
                      >
                        <FontAwesomeIcon
                          icon={faUpRightFromSquare}
                          className={styles.icon}
                        />
                      </a>
                    )}
                  </span>
                </Checkbox>
              </InputAreaDupla>
            ))}
        </section>

        <AlignRight>
          <ContainedBtn className={styles.submitBtn} disabled={loading}>{loading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Enviar"}</ContainedBtn>
        </AlignRight>
      </form >
    </>
  );
}

export default CadastroQot;
